import axiosInstance from "../../../components/authentication/helper/axiosApi";
import { ActionTypes } from "../../constants/action-types";

export const fetchDashboardAction = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`/api/analytics/dashboardPeerRanking/`);
            dispatch({
                type: ActionTypes.SET_DASHBOARD,
                payload: response.data,
            });
        }
        catch (error) {

        }
    };
};

